import { createRef, RefObject, useEffect, useState } from 'react';

//this hook will focus a specific element based on the # route

export const useHashRouter = (route: string, defaultRef?: RefObject<any>) => {
  //use state to set ref, so that if ref comes from external source, we always get
  //a reference to that ref
  const [ref] = useState(defaultRef ? defaultRef : createRef<any>());
  const hash = window.location.hash.substr(1);
  useEffect(() => {
    if (route === hash && ref.current) {
      ref.current.focus();
      window.scrollTo(0, ref.current.offsetTop);
    }
  }, [route, hash, ref]);
  return ref;
};
